import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MonochromePhotosIcon(props: IconProps) {
    return <Icon {...props} iconKey={"monochrome_photos"}/>
}
